import styled from "styled-components";

export const SearchLinksListDefaultBox = styled.ul`
      margin: 0 0 2rem 0;
      padding: 0;
      border-left: 2px solid ${props => props.theme.colors.boxBorderLight};
`;